module.exports = {"360702001":"解放街道","360702002":"赣江街道","360702003":"南外街道","360702004":"东外街道","360702091":"黄金岭街道（赣州经济技术开发区）","360702100":"沙石镇","360702101":"水东镇","360702102":"水南镇","360702103":"湖边镇（赣州经济技术开发区）","360702104":"沙河镇","360702105":"水西镇","360702190":"蟠龙镇（赣州经济技术开发区）","360702191":"潭口镇（赣州蓉江新区）","360702192":"潭东镇（赣州蓉江新区）","360702400":"赣州经济技术开发区","360702401":"沙河工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360702.json
// module id = 1285
// module chunks = 0